import "./tarifsTextCartouche.css";

function TarifsTextCartouche({
  children,
  bTop = "10px",
  bLeft = "10px",
  bRight = "10px",
  bBot = "10px",
}) {
  return (
    <div
      className="tarif-text-cartouche-contenair"
      style={{
        marginTop: bTop,
        marginLeft: bLeft,
        marginRight: bRight,
        marginBottom: bBot,
      }}
    >
      <div className="tarif-text-cartouche">{children}</div>
    </div>
  );
}

export default TarifsTextCartouche;
